/**
 * TXM-594 — domínios fechados da Tabela NCM.
 *
 * Mesmos valores do CHECK CONSTRAINT em public.tabela_ncm_item: se divergirem, o banco
 * rejeita a gravação. CLASSIFICACOES também precisa bater com as listas já usadas em
 * ClassificacaoNcm/icmsClassificacaoClienteStore.js e LancamentosEcredac.
 */

export const TIPOS_ITEM = [
  "Matéria-Prima",
  "Embalagem",
  "Material de Uso e Consumo",
  "Produto Acabado",
  "Serviço",
];

export const CLASSIFICACOES = ["Insumo", "Uso", "Consumo"];

/**
 * Mesmos valores do CHECK de metodo_calculo (migration v6). A API faz trim + UPPER, então o
 * select só oferece as formas canônicas. Sem opção escolhida (null) = herda do nível acima.
 */
export const METODOS_CALCULO = [
  { valor: "PMC", rotulo: "PMC" },
  { valor: "MVA", rotulo: "MVA" },
  { valor: "-", rotulo: "Não se aplica (-)" },
];

export const UFS = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG",
  "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
];
